<p>Authentication</p>

<div class="-mat-error" *ngIf="hasError">
  {{ errorMessage }}
  <button (click)="logoutClicked()">Logout</button>
</div>
